import GenericActionButtons from "../../GenericTaskActionButtons";
import {OpenPublishingTaskResult} from "services/tasks/models/tasksTypes";
import {RefObject, useState} from "react";
import {TaskActionsNames} from "services/shared-models/sharedTypes";
import GenericActionsModal from "../../OrderTaskActionModals/GenericActionsModal";
import {AdminTapActionsRef} from "../CourseOrderAdminView";
import {tabsIds} from "../../orderPage.types";
import {useTranslation} from "react-i18next";
import {BackendServices} from "../../../../../../services";
import {useNavigate, useParams} from "react-router-dom";
import ReturnOrderToReviewerModal from "./ReturnOrderToReviewerModal";
import {CourseOrderLocalItemResult} from "../../../../../../services/courseOrder/models/CourseOrderType";
import {ModalProps} from "../../../../../../components/blocks/Modal";
import ReturnRefereeOrderToReviewerModal from "../CourseOrderRefereeManagementView/ReturnRefereeOrderToReviewerModal";

const Actions = ({
                     selectedTabId,
                     openTask,
                     submitRef,
                     hasCustomActions,
                     customActionKey,
                     order,
                    dialogType
                 }: {
    selectedTabId: string;
    openTask: OpenPublishingTaskResult | null;
    submitRef: RefObject<AdminTapActionsRef>;
    hasCustomActions?: boolean;
    customActionKey?: string;
    order? : CourseOrderLocalItemResult | null
    dialogType?: "referee" | "examiner" | "ISBN" 
}) => {
    const {t} = useTranslation("Orders");
    const [openActionModal, setOpenActionModal] = useState<{
        isOpen: boolean;
        msg: string;
        type?: string;
        loading?: boolean;
    }>();   
    const [modalProps, setModalProps] = useState<ModalProps>();
    const {serialGID} = useParams();
    const navigate = useNavigate();
    const onSubmit = async (action: TaskActionsNames, openTask: OpenPublishingTaskResult | null, notes: string,filesIds:string[]) => {
        let isSpecificAction = false
        if (submitRef.current?.globalSubmit) {
            let result  = await submitRef.current?.globalSubmit(action, openTask, notes,filesIds);
            if(result === 0 ) isSpecificAction=false
            else if(result===1) isSpecificAction=true
            else if(result==-1)
            {
                setOpenActionModal((mydata: any) => {
                    return {...mydata, loading: false}
                });
                return;
            }
        }

        if (!isSpecificAction) {
            if (openTask != null) {
                const res = await BackendServices.workflowService.WorkflowAction(openTask?.courseOrderId ?? 0, {
                    actionName: action,
                    serialGuid: serialGID ?? "",
                    activityGuid: openTask.activityGuid ?? "",
                    notes: notes ?? "",
                    filesIds: filesIds ?? [],

                });

                if (res.hasError) {
                    setOpenActionModal((mydata: any) => {
                        return {...mydata, loading: false}
                    });
                    return;
                }
                setOpenActionModal(undefined);
            }

        } else
            setOpenActionModal(undefined);
        navigate(-1);

    };

    return (
        <>
            {selectedTabId === tabsIds.info ? (
                <>
                    {hasCustomActions && customActionKey === "ReturnToAuther" && 
                        (<>
                            <button
                                className={`btn btn-outline-secondary px-3`}
                                onClick={() =>{
                                    setModalProps({isOpen: true})
                                } }
                            >
                                {t("ReturnToAuthor")}
                            </button>
                        </>)
                    }
                    
                    <GenericActionButtons
                        loading={false}
                        openedTask={openTask}
                        IgnoreKey={customActionKey}
                        onActionClick={(action, msg) => {
                            setOpenActionModal({isOpen: true, msg, type: action});
                        }}
                    />
                </>
            ) : (
                <button
                    key="save"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        submitRef.current?.submit();
                    }}
                    className="btn btn-primary btn-sm rounded p-10-32P"
                >
                    {t("save")}
                </button>
            )}

            <GenericActionsModal
                isOpen={openActionModal !== undefined}
                onClose={() => setOpenActionModal(undefined)}
                isSubmitting={openActionModal?.loading ?? false}
                order={order}
                actionKey={openActionModal?.type}
                onSubmit={async (notes,filesIds) => {
                    setOpenActionModal((mydata: any) => {
                        return {...mydata, loading: true}
                    });
                    await onSubmit(openActionModal?.type as TaskActionsNames, openTask, notes, filesIds);
                }}
                type={openActionModal?.type}
                msg={openActionModal?.msg ?? ""}
            />

            {openTask?.courseOrderId && dialogType =="examiner" &&  
                <ReturnOrderToReviewerModal
                isOpen={modalProps?.isOpen}
                isInspectMode={order?.isInspectMode}
 
                onClose={() => {
                    setModalProps({ isOpen: false });
                }}
                orderId={openTask?.courseOrderId ?? 0}
                activityGuid={openTask?.activityGuid}
                serialGuid={serialGID}
            />}    
            {openTask?.courseOrderId && dialogType =="referee" &&     <ReturnRefereeOrderToReviewerModal
                isOpen={modalProps?.isOpen}
                isInspectMode={order?.isInspectMode}
 
                onClose={() => {
                    setModalProps({ isOpen: false });
                }}
                orderId={openTask?.courseOrderId ?? 0}
                activityGuid={openTask?.activityGuid}
                serialGuid={serialGID}
            />}

        </>
    );
};

export default Actions;
